module.exports = __webpack_public_path__ + "img/generic.bd491f18.jpeg";